import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_FOOTER_HEIGHT,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const FormFooterStyled = styled.footer.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "form-footer-styled",
})<{
  $isCentered?: boolean;
}>`
  border-top: 1px solid ${greyMui._300};
  display: flex;
  align-items: center;
  padding-inline: 24px;
  justify-content: ${props => (props.$isCentered ? "center" : "flex-end")};
  height: ${DRAWER_FOOTER_HEIGHT}px;
  gap: 12px;

  transition:
    filter 0.55s ease-out,
    backdrop-filter 0.55s ease-out;
  &.inner-item-editing {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .MuiButton-root {
      line-height: normal;
    }
  }
`;
